import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { assignmentTypes } from '../authorization/assignmentTypes';

const AssignmentTypeCodesMap = {
  Country: assignmentTypes.COUNTRIES,
  Connection: assignmentTypes.CONNECTIONS,
  'Business Unit': assignmentTypes.BUSINESS_UNITS,
  'Company Code': assignmentTypes.COMPANY_CODES,
  Business: assignmentTypes.BUSINESSES,
  All: assignmentTypes.ALL,
};

class CheckboxRenderer extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    checkAll: PropTypes.func,
    checkedValues: PropTypes.arrayOf(PropTypes.string).isRequired,
    allChecked: PropTypes.bool,
    assignmentType: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    readOnly: PropTypes.bool.isRequired,
    data: PropTypes.shape({
      assignmentType: PropTypes.string,
      checked: PropTypes.bool,
      indeterminate: PropTypes.bool,
      fromRole: PropTypes.bool,
    }).isRequired,
  };

  onChange = event => {
    const assignmentType = this.props.assignmentType === 'ASSIGNMENT'
      ? AssignmentTypeCodesMap[this.props.data.assignmentType]
      : this.props.assignmentType;

    this.props.onChange(
      this.props.value,
      event.target.checked,
      assignmentType
    );
  };

  checkAll = () => {
    if (this.props.allChecked) {
      this.props.checkAll(false, this.props.assignmentType);
      return;
    }

    this.props.checkAll(true, this.props.assignmentType);
  };

  render() {
    const { value, readOnly, data } = this.props;

    if (value !== 'All') {
      return (
        <div className="d-flex justify-content-center assignment-checkbox-with-role-indicator">
          <input
            type="checkbox"
            checked={data.checked}
            name="isSelected"
            onChange={this.onChange}
            disabled={readOnly}
          />
          <div className="from-role-indicator">
            { data.fromRole ? '(Role)' : '' }
          </div>
        </div>
      );
    }

    return (
      <div className="d-flex justify-content-center assignment-checkbox-with-role-indicator">
        <input
          type="checkbox"
          checked={data.checked}
          name="isSelected"
          onChange={this.checkAll}
          disabled={readOnly}
        />
        <div className="from-role-indicator">
          { data.fromRole ? '(Role)' : '' }
        </div>
      </div>
    );
  }
}

export default () => props => <CheckboxRenderer {...props} />; // eslint-disable-line react/display-name
